import CertsListTile from './CertsListTile';

export { getTileMetaData } from './utils';

export default CertsListTile;
